import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Applicant } from '../../models/applicant';
import { ApplicantSelfRegistrationRequest } from '../../models/applicantSelfRegistrationRequest';
import { AuthenticationStorageService } from '../../services/authentication-storage.service';
import { environment } from '../../../../../environments/environment';
import { CaptchaService } from '../../services/captcha.service';

@Component({
  selector: 'app-applicant-profile-registration',
  templateUrl: './applicant-profile-registration.component.html',
  styleUrls: ['./applicant-profile-registration.component.scss'],
})
export class ApplicantProfileRegistrationComponent implements OnInit {
  private countdown!: number;
  private timerInterval!: any;
  timerText: string = '5:00';
  timelimit = 300;
  display: string = '05:00'; // Initial display (5 minutes)
  submitOtpToMobile: boolean = false;
  showResendOTP: boolean = false;
  otpIsLoading: boolean = false;
  alreadySmsSend: boolean = false;
  siteKey: string;
  isProd = environment.production;
  showCaptcha: boolean = false;
  captchaToken: string | null = null;

  applicantProfileRegistrationForm: FormGroup;
  otpForm!: FormGroup;

  freelancer!: Applicant;
  selfRegistrationRequest!: ApplicantSelfRegistrationRequest;
  regex = /[a-zA-Z]*/;

  tempNumber = 0;
  isVisible = false;
  validateForm!: FormGroup;
  contactNumber!: string;
  receivedOtp!: string;
  nzFooterVisible = false;
  emailAlredyExist = false;
  nameAlredyExist = false;

  passwordVisible = false;
  confirmPasswordVisible = false;

  userInput: any;
  captchaError: boolean = false;
  captchaText: string;

  nidAlredyExist = false;

  constructor(
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private authStorageService: AuthenticationStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private captchaService: CaptchaService,
  ) {
    this.applicantProfileRegistrationForm = this.fb.group({
      name: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/),
          this.noWhitespaceValidator,
          this.noTrailingSpaceValidator,
        ],
      ],
      nid: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(01)?(\d{10}|\d{13}|\d{17})$/),
        ],
      ],
      email: [null, [Validators.email, Validators.required]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(64),
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@#$!%?&^*;:,<>.`~-])[A-Za-z\d$@#$!%?&^*;:,<>.`~-]+$/,
          ),
        ],
      ],
      confirmPassword: [
        '',
        [Validators.required, Validators.maxLength(64), this.confirmValidator],
      ],
      contactNumberPrefix: ['+880'],
      contactNumber: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern(/^1[3-9][0-9]{8}$/),
        ],
      ],
      captcha: new FormControl('', Validators.required),
    });
    this.otpForm = this.fb.group({
      otp: [
        '',
        [Validators.required, Validators.pattern(/^(?:\01)?(?:\d{5})$/)],
      ],
    });
  }

  ngOnInit() {
    this.captchaText = this.captchaService.captchaGenerator();
  }

  submitForm(): void {
    console.log('--> ' + this.applicantProfileRegistrationForm.controls);
    for (const key of Object.keys(
      this.applicantProfileRegistrationForm.controls,
    )) {
      this.applicantProfileRegistrationForm.controls[key].markAsDirty();
      this.applicantProfileRegistrationForm.controls[
        key
      ].updateValueAndValidity();
    }
    console.log(this.applicantProfileRegistrationForm.value);
    this.refreshCaptcha();
    //this.showModal();
    this.startCountdown(this.timelimit);
    this.sendOtpTouser();
    this.showModal();
  }

  submitOtp(): void {
    this.receivedOtp = this.otpForm.get('otp')?.value;

    const selfRegistrationRequest = new ApplicantSelfRegistrationRequest();

    selfRegistrationRequest.email =
      this.applicantProfileRegistrationForm.controls.email.value;

    selfRegistrationRequest.contactNumber =
      this.applicantProfileRegistrationForm.controls.contactNumber.value;

    selfRegistrationRequest.contactNumberPrefix =
      this.applicantProfileRegistrationForm.controls.contactNumberPrefix.value;

    selfRegistrationRequest.name =
      this.applicantProfileRegistrationForm.controls.name.value;

    selfRegistrationRequest.password =
      this.applicantProfileRegistrationForm.controls.confirmPassword.value;

    selfRegistrationRequest.nid =
      this.applicantProfileRegistrationForm.controls.nid.value;

    selfRegistrationRequest.role = 'Applicant, Assessor';

    // selfRegistrationRequest.designation = this.applicantProfileRegistrationForm.controls.stpDesignation.value;

    this.authStorageService
      .getVerifiedOtp(this.receivedOtp, this.contactNumber)
      .subscribe({
        next: (response) => {
          this.authStorageService
            .createApplicant(selfRegistrationRequest)
            .subscribe({
              next: (serverResponse) => {
                this.selfRegistrationRequest = serverResponse.data;
                // const applicant = new Applicant();

                // applicant.userId = this.selfRegistrationRequest.id;

                // applicant.nid =
                //   this.applicantProfileRegistrationForm.controls.nid.value;

                // applicant.name =
                //   this.applicantProfileRegistrationForm.controls.name.value;

                // applicant.applicantEmail =
                //   this.applicantProfileRegistrationForm.controls.email.value;

                // applicant.applicantMobileNo =
                //   this.applicantProfileRegistrationForm.controls.mobileNo.value;

                // this.saveApplicantProfile(applicant);

                this.applicantProfileRegistrationForm.reset();
                const returnUrl =
                  this.route.snapshot.queryParams.returnUrl || '/login';
                this.router.navigateByUrl(returnUrl);
                this.notification.success(
                  'Success!',
                  'Please check your email for validation',
                );
                //this.isVisible = false;
              },

              error: (error) => {
                this.notification.error(error, error.message);
              },
            });
        },
        error: (error) => this.notification.error('Failed', 'OTP is not valid'),
      });
    this.otpForm.reset();

    // this.validateForm.reset();
  }

  confirmValidator = (control: FormControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    if (
      control.value !==
      this.applicantProfileRegistrationForm.controls.password.value
    ) {
      return { confirm: true };
    }

    return null;
  };
  
  checkEmailExist(email: any): void {
    this.emailAlredyExist = false;
    setTimeout(() => {
      if (email.value.length > 3) {
        this.authStorageService
          .checkApplicantEmailExist(email.value)
          .subscribe({
            next: (res) => {
              if (res.data == null) {
                this.emailAlredyExist = false;
              } else {
                this.emailAlredyExist = true;
                this.applicantProfileRegistrationForm.controls.email.setErrors({
                  incorrect: true,
                });
              }
            },
          });
      }
    }, 2000);
  }

  checkNameExist(name: any): void {
    this.nameAlredyExist = false;
    setTimeout(() => {
      if (name.value.length > 3) {
        this.authStorageService.checkApplicantEmailExist(name.value).subscribe({
          next: (res) => {
            if (res.data == null) {
              this.nameAlredyExist = false;
            } else {
              this.nameAlredyExist = true;
              this.applicantProfileRegistrationForm.controls.name.setErrors({
                incorrect: true,
              });
            }
          },
        });
      }
    }, 2000);
  }

  validateConfirmPassword(): void {
    setTimeout(() =>
      this.applicantProfileRegistrationForm.controls.confirmPassword.updateValueAndValidity(),
    );
  }

  nidValidation(control: AbstractControl) {
    if (control.value.length <= 10) {
      return { error: true, required: true };
    } else if (control.value.length <= 17) {
      return { error: true, required: true };
    }
    return {};
  }

  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.applicantProfileRegistrationForm.reset();
    this.applicantProfileRegistrationForm
      .get('contactNumberPrefix')
      ?.setValue('+880');

    for (const key of Object.keys(
      this.applicantProfileRegistrationForm.controls,
    )) {
      this.applicantProfileRegistrationForm.controls[key].markAsPristine();
      this.applicantProfileRegistrationForm.controls[
        key
      ].updateValueAndValidity();
    }
  }

  saveApplicantProfile(applicant: Applicant): void {
    this.authStorageService.createApplicantUser(applicant).subscribe({
      next: (serverResponse) => {
        console.log(serverResponse);
        this.applicantProfileRegistrationForm.reset();
        const returnUrl = this.route.snapshot.queryParams.returnUrl || '/login';
        this.router.navigateByUrl(returnUrl);
        this.notification.success(
          'Success!',
          'Please check your email for validation',
        );
      },
      error: (error) => {
        this.notification.error(error, error.message);
      },
    });
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  noTrailingSpaceValidator(control: AbstractControl) {
    const value = control.value;
    if (value && value.endsWith(' ')) {
      return { trailingSpace: true };
    }
    return null;
  }

  //#region OTP

  sendOtpTouser(): void {
    this.isVisible = true;
    this.contactNumber =
      '0' + this.applicantProfileRegistrationForm.get('contactNumber')?.value;
    this.authStorageService.getOtp(this.contactNumber).subscribe({
      next: (res) => {
        console.log('Message Send');
        console.log(res.message);
        if (res.success == true) {
          this.notification.success('Success!', res.message);
          this.isVisible = true;
        } else {
          this.notification.error('Failed!', res.message);
          this.isVisible = false;
        }
      },
      error: (error) =>
        this.notification.error(
          'Failed',
          'OTP is not Sent, Please try again later',
        ),
    });
    // this.isVisible = true;
    //  this.nzFooter = false;
    setTimeout(() => {
      this.isVisible = false;
    }, 300000);
  }

  /* showModal(): void {
     this.isVisible = false;
     this.contactNumber =
       '0' + this.assessorRegForm.get('contactNumber')?.value;
     this.authStorageService.getOtp(this.contactNumber).subscribe({
       next: (res) => {
         if(res.success == true){
           this.notification.success(
             'Success!', res.message
           );
           this.isVisible = true;
         }else{
           this.notification.error(
             'Failed!', res.message
           );
           this.isVisible = false;
         }
       },
       error: (error) => this.notification.error('Failed', 'OTP is not Send, Please try again later'),
     });
     // this.isVisible = true;
     //  this.nzFooter = false;
     setTimeout(() => {
       this.isVisible = false;
     }, 300000);
   }


   handleOk(): void {
     this.isVisible = false;
   }*/

  /* handleCancel(): void {
     this.isVisible = false;
   }*/

  //#endregion OTP

  refreshCaptcha() {
    this.captchaText = this.captchaService.captchaGenerator();
    this.captchaError = false;
  }
  verify() {
    if (this.userInput === this.captchaText) {
      this.submitForm();
    } else {
      this.notification.error('Invalid!', 'Please correct the CAPTCHA!');
      this.captchaError = true;
    }
  }

  checkNidExist(nid: any): void {
    this.nidAlredyExist = false;
    setTimeout(() => {
      if (nid.value.length > 9) {
        this.authStorageService.checkApplicantNidExist(nid.value).subscribe({
          next: (res) => {
            if (res.data == null) {
              this.nidAlredyExist = false;
            } else {
              this.nidAlredyExist = true;
              this.applicantProfileRegistrationForm.controls.nid.setErrors({
                incorrect: true,
              });
            }
          },
        });
      }
    }, 2000);
  }

  /****** new OTP ******/

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.resetCountdown();
  }

  startCountdown(durationInSeconds: number) {
    this.countdown = durationInSeconds;

    this.timerInterval = setInterval(() => {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      this.timerText = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      if (this.countdown <= 0) {
        this.resetCountdown();
        //this.isVisible=false;
        this.isVisible = true;
      } else {
        this.countdown--;
      }
      if (this.countdown === 0) {
        this.showResendOTP = true;
        this.alreadySmsSend = false;
      }
    }, 1000);
  }
  resetCountdown() {
    clearInterval(this.timerInterval);
    this.timerText = '5:00'; // Reset UI
  }
  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }

  resendOTP(): void {
    this.otpIsLoading = true;
    if (!this.applicantProfileRegistrationForm.valid) {
      Object.keys(this.applicantProfileRegistrationForm.controls).forEach(
        (key) => {
          this.applicantProfileRegistrationForm.controls[key].markAsDirty();
          this.applicantProfileRegistrationForm.controls[
            key
          ].updateValueAndValidity();
        },
      );
      this.otpIsLoading = false;
      return;
    }

    const mobileControl =
      this.applicantProfileRegistrationForm.controls['contactNumber'];
    this.authStorageService.getOtp('0' + mobileControl.value).subscribe({
      next: () => {
        console.log('OTP sent successfully');
        this.notification.success(
          'OTP Sent',
          'An OTP has been sent to your phone number.',
        );
        this.submitOtpToMobile = true;
        this.startCountdown(this.timelimit);
        this.showModal();
        this.otpIsLoading = false;
        this.alreadySmsSend = true;
      },
      error: () => {
        this.notification.error(
          'Failed',
          'Failed to send OTP, please try again.',
        );
        this.otpIsLoading = false;
      },
    });
  }
}
